/**
 * Known list of fallback text from the API that
 * should be handled programmatically as null.
 */
const API_NULL_FALLBACKS = new Set(['unknown', 'n/a', 'none', 'null', 'undefined']);

/**
 * Helper to transform API fallback strings into actual nulls.
 * Useful as a Zod preprocessor to clean up dirty data.
 */
export const emptyToNull = (value: unknown): unknown => {
  // 1. If the value is not a string, return the original intact
  const isString = typeof value === 'string';
  if (!isString) {
    return value;
  }

  // 2. Normalize the string (trim whitespace and convert to lowercase)
  const normalizedString = value.toLowerCase().trim();

  // 3. Evaluate if the string is empty or matches any of our API null return texts
  const isEmptyOrFallback = normalizedString === '' || API_NULL_FALLBACKS.has(normalizedString);

  if (isEmptyOrFallback) {
    return null;
  }

  // 4. If it's a valid and clean string, return the original
  return value;
};
